<template>
    <div class="col-lg-6 mb-4">
        <div class="box">
            <div class="box-offset">
                <div class="box-ttl-wrap">
                    <div class="box-ttl">To Do’s <span class="box-ttl-number-box">{{listOfTodo.length}}</span></div>
                    <div
                        class="btn btn--outline-primary btn--small"
                        @click="createNewTodo"
                    >+ Add</div>
                </div>
                <div v-if="listOfTodo.length > 0"
                     class="table-holder table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>To Do</th>
                            <th >Priority</th>
                            <th class="text-right">Due date</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                            v-for="todo in listOfTodo"
                            :key="todo.id"
                        >
                            <td>
                                <div>
                                    <div class="color--dark-text">
                                       <a
                                           class="color--dark-text"
                                           :href="`/master-admin/to-do/${todo.id}/edit`"
                                       >
                                           <p>
                                               <b>{{todo.title}}</b>
                                           </p>
                                       </a>
                                    </div>

                                    <div class="small-text">
                                        <span>From</span>
                                        <em>{{ todo.creator.name }} {{ todo.creator.last_name }}</em> |
                                        <span>{{todo.created_at | momentFromNow }}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span :class="showColorPriority(todo.priority)">
                                    {{ todo.priority | capitalizeFirst }}
                                </span>
                            </td>
                            <td class="text-right">
                                {{todo.dead_line ? calculateDate(todo.dead_line) : ''}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="listOfTodo.length < 0">
                    <h1>To-Do list is empty</h1>
                </div>
                <div class="text-center" v-if="listOfTodo.length > 0">
                    <a href="/master-admin/to-do" class="link">View All</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import DashboardService from "./DashboardService";
import DateConverter from "../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'TodoBoard',
    mixins: [StyleHandler, DateConverter],
    data() {
        return {
            loading: true,
            listOfTodo: [],
            filters: {
                status: 'pending',
                type: 'inbox',
                sortBy: 'date',
                sortDir: 'desc',
            },
        }
    },
    methods: {
        createNewTodo() {
           window.location.href = '/master-admin/to-do/create'
        },
        async getTodoList() {
            try {
                const {data: todoInfo} = await DashboardService.getTodoInfo(this.filters)
                this.listOfTodo = todoInfo
            } catch (error) {
               this.$showErrorMessage('The to-do list was not uploaded. Please reload page')
            }
        },
    },
    mounted() {
        this.getTodoList()
    }

}

</script>



<style scoped>

</style>
